import { BulkReassigned, TaskControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
interface Params {
  bulkReassigned: BulkReassigned;
  xTENANTID?: string;
}

export const useBatchReassign = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).taskReassignTasks(
      params?.bulkReassigned,
      params.xTENANTID
    )
  );
